import { Box, Grid } from '@mui/material';
import { applicationHelperTexts } from 'utils/hint.utils';
import gaTrackingIdSchema from 'FeatureModules/Setting/schemas/gaTrackingId.schemas';
import { ThemeButton, FieldWrapper } from 'DesignSystem';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import PropTypes from 'prop-types';
import React from 'react';

const GATrackingIdForm = ({ onSubmit, gaTrackingId }) => {
  return (
    <Formik
      initialValues={{
        gaTrackingId: gaTrackingId,
      }}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={gaTrackingIdSchema}
      onSubmit={values => onSubmit(values)}
    >
      {({ isSubmitting }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid item xs={8}>
              <Box>
                <FieldWrapper
                  label="Tracking-ID or Measurement-ID"
                  subtitle="Use the Google Tracking-ID/Measurement-ID to add Google Analytics to your products"
                  tooltip={{
                    variant: 'INFO',
                    helperText: applicationHelperTexts.tracking.trackingId,
                  }}
                >
                  <Field
                    component={TextField}
                    fullWidth
                    placeholder="G-XXXXXXXXXX"
                    name="gaTrackingId"
                    variant="outlined"
                    data-testid="ga-tracking-id-input"
                  />
                </FieldWrapper>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" gap={2.5}>
                <ThemeButton
                  color="PRIMARY"
                  size="large"
                  loading={isSubmitting}
                  type="submit"
                  data-testid="ga-tracking-id-submit"
                >
                  Update
                </ThemeButton>
              </Box>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

GATrackingIdForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  gaTrackingId: PropTypes.string,
};

export default GATrackingIdForm;
